import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';

function usePagination(data, itemsPerPage) {
  var _useState = useState(1),
      _useState2 = _slicedToArray(_useState, 2),
      currentPage = _useState2[0],
      setCurrentPage = _useState2[1];

  var maxPage = Math.ceil(data.length / itemsPerPage);

  function currentData() {
    var begin = (currentPage - 1) * itemsPerPage;
    var end = begin + itemsPerPage;
    return data.slice(begin, end);
  }

  function next() {
    setCurrentPage(function (currentPage) {
      return Math.min(currentPage + 1, maxPage);
    });
  }

  function prev() {
    setCurrentPage(function (currentPage) {
      return Math.max(currentPage - 1, 1);
    });
  }

  function jump(page) {
    var pageNumber = Math.max(1, page);
    setCurrentPage(function (currentPage) {
      return Math.min(pageNumber, maxPage);
    });
  }

  return {
    next: next,
    prev: prev,
    jump: jump,
    currentData: currentData,
    currentPage: currentPage,
    maxPage: maxPage
  };
}

export default usePagination;